module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Code/Control-c8d655894d204fa6ec1ff7bc77a6f0a0.svg";